import type { IconConfig } from '../types'
import { IconBuilder, type RenderOptions } from './IconBuilder'
import { CanvasRenderer } from './render'

export interface PreviewOptions extends RenderOptions {
  showSafeZone?: boolean
  showGrid?: boolean
}

export class IconPreview {
  private readonly builder: IconBuilder

  constructor(private readonly config: IconConfig) {
    this.builder = new IconBuilder(config)
  }

  resolveOptions(): Promise<RenderOptions> {
    return this.builder.resolveOptions()
  }

  drawTo(context: CanvasRenderingContext2D, size: number, options: PreviewOptions = {}): void {
    const renderer = new CanvasRenderer(context, size)

    this.builder.renderTo(renderer, options)

    if (options.showGrid) {
      renderer.drawGrid()
    }

    if (options.showSafeZone) {
      renderer.drawSafeZone(this.config.corners)
    }

    renderer.finalize()
  }
}
